import { get as getFromCookie, CS_DISABLE_ANALYTICS } from '../cs';

export const CURRENCY = 'USD';
export const ANALYTICS_IS_DISABLED = Boolean(parseInt(getFromCookie(CS_DISABLE_ANALYTICS, 0), 10));
